import { render } from "./BeatdayPcMac.vue?vue&type=template&id=a5b9bd1c"
import script from "./BeatdayPcMac.vue?vue&type=script&lang=js"
export * from "./BeatdayPcMac.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__